import { useEffect, useRef, useState } from "react";
// Jds
import {
  Container,
  Text,
  Notifications,
  Button,
  Image as UIImage,
} from "@jds/core";
// Mui
import { Box } from "@mui/material";
//Img
import noFrameStateImg from "../../../assets/png/no-frame.png";
import port from "../../../assets/portrait.jpg";
import land from "../../../assets/landscape.jpg";
//helper
import { imgValidationCheck } from "../../../util/helper";
import useApiHttp from "../../../hooks/use-http";
import { useParams } from "react-router-dom";
import PageLoader from "../Loader/PageLoader";
import decryptUrl from "../../../util/img-decryption";

const FrameModal = (props) => {
  const { closeModal } = props;
  const [frameData, setFrameData] = useState();
  const { id: eventId } = useParams();
  const frameFileInputRef = useRef(null);
  const { sendRequest: frameUpload, isLoading: frameUploading } = useApiHttp();
  const { sendRequest: getFrame, isLoading: frameGetting } = useApiHttp();
  const { sendRequest: deleteFrame, isLoading: frameDeleting } = useApiHttp();
  const handleUploadFrameClick = () => {
    frameFileInputRef.current.click();
  };
  const hadleFrameFileChange = (event) => {
    const selectedFiles = Array.from(event.target.files);
    if (selectedFiles.length !== 2) {
      Notifications.toast.error({
        id: "frame-input-img",
        title: "Please select the two files.",
      });
      return;
    }
    if (
      !imgValidationCheck(null, selectedFiles[0]) ||
      !imgValidationCheck(null, selectedFiles[1])
    ) {
      Notifications.toast.error({
        id: "frame-input-img",
        title: "Please upload a valid image file (JPG, JPEG and PNG).",
      });
      event.target.value = "";
      return;
    }

    const imagePromises = selectedFiles.map((file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => {
          const img = new Image();
          img.onload = () => {
            resolve({
              file,
              width: img.width,
              height: img.height,
            });
          };
          img.onerror = reject;
          img.src = e.target.result;
        };
        reader.readAsDataURL(file);
      });
    });

    Promise.all(imagePromises)
      .then((loadedImages) => {
        const isPortrait = (img) => img.height >= img.width;
        const portraitImage = loadedImages.find(isPortrait);
        const landscapeImage = loadedImages.find((img) => !isPortrait(img));
        if (portraitImage && landscapeImage) {
          const formData = new FormData();
          formData.append("eventId", eventId);
          formData.append("portraitFrame", portraitImage.file);
          formData.append("landscapeFrame", landscapeImage.file);
          formData.append("frameStatus", true);
          frameUpload(
            {
              url: "frame/uploadFrame",
              method: "POST",
              base: "MEDIA",
              formData: true,
              body: formData,
            },
            null,
            (data) => {
              closeModal && closeModal();
              Notifications.toast.success({
                id: "frame-input-img",
                title: data?.message,
              });
            },
            (err, data) => {
              Notifications.toast.error({
                id: "frame-input-img",
                title: data?.message,
              });
            }
          );
        } else {
          Notifications.toast.error({
            id: "frame-input-img",
            title: "Please select one portrait and one landscape image.",
          });
          event.target.value = "";
        }
      })
      .catch(() => {
        Notifications.toast.error({
          id: "frame-input-img",
          title: "Please upload a valid image file (JPG, JPEG and PNG).",
        });
      });
  };
  const handleDeleteFrame = () => {
    deleteFrame(
      {
        url: `frame/delete-frame?eventId=${eventId}`,
        method: "DELETE",
        base: "MEDIA",
      },
      null,
      (data) => {
        closeModal && closeModal();
        Notifications.toast.success({
          id: "frame-delete",
          title: "Frame deleted successfully.",
        });
      },
      (err, data) => {
        closeModal && closeModal();
        Notifications.toast.error({
          id: "frame-delete",
          title: data?.message,
        });
      }
    );
  };
  useEffect(() => {
    getFrame(
      {
        url: `frame/frame-details?eventId=${eventId}`,
        method: "GET",
        base: "MEDIA",
      },
      null,
      (data) => {
        setFrameData(data?.data);
      },
      (err, data) => {
        console.log("error", data);
      }
    );
  }, []);
  return (
    <Container
      fullWidth
      direction="column"
      horizontalAlign="center"
      gap={"40px"}
    >
      {frameData?.portraitFrame && frameData?.landscapeFrame ? (
        <div>
          <Container
            gap={"16px"}
            horizontalAlign="center"
            direction="row"
            verticalAlign="end"
          >
            {/* <Box
            position="relative"
            sx={{
              width: "250px",
            }}
          >
            <UIImage apectRatio="3:4" src={port} roundedCorner={false} />
            <Box
              position="absolute"
              sx={{ left: 0, height: "100%", width: "100%", top: 0 }}
            >
              <UIImage
                apectRatio="3:4"
                src={frameData?.portraitFrame || ""}
                roundedCorner={false}
              />
            </Box>
          </Box>
          <Box
            position="relative"
            sx={{
              height: "300px",
            }}
          >
            <UIImage
              apectRatio="16:9"
              src={land}
              contentScale="fit"
              roundedCorner={false}
            />
            <Box
              position="absolute"
              sx={{ left: 0, height: "100%", width: "100%", top: 0 }}
            >
              <UIImage
                apectRatio="4:3"
                src={frameData?.landscapeFrame || ""}
                contentScale="fit"
                roundedCorner={false}
              />
            </Box>
          </Box> */}

            <div
              style={{
                position: "relative",
                width: "150px",
              }}
            >
              <img
                src={decryptUrl(frameData?.portraitFrame) || ""}
                style={{
                  objectFit: "cover",
                  width: "100%",
                  height: "100%",
                }}
              />
              <img
                src={port}
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  objectFit: "cover",
                  zIndex: -10,
                  width: "100%",
                  height: "100%",
                }}
              />
            </div>

            <div
              style={{
                position: "relative",
                width: "200px",
              }}
            >
              <img
                src={decryptUrl(frameData?.landscapeFrame) || ""}
                style={{
                  objectFit: "cover",
                  width: "100%",
                  height: "100%",
                }}
              />
              <img
                src={land}
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  objectFit: "cover",
                  zIndex: -10,
                  width: "100%",
                  height: "100%",
                }}
              />
            </div>
          </Container>
        </div>
      ) : (
        <>
          <Container fullWidth>
            <Text
              appearance="body-m-bold"
              color="primary-grey-80"
              text="Choose from default frames or upload your own frame. Please select one frame for portrait orientation and another frame for landscape orientation."
              textAlign="center"
            />
          </Container>

          <Box width={176}>
            <img src={noFrameStateImg} alt="photo frame" />
          </Box>
        </>
      )}

      <Container fullWidth horizontalAlign="center" direction="column" gap={16}>
        <input
          type="file"
          id="photo_frame"
          name="frame_img"
          accept=".jpeg,.jpg,.png"
          style={{ display: "none" }}
          multiple
          onChange={(e) => {
            hadleFrameFileChange(e);
          }}
          ref={frameFileInputRef}
        />
        <Container fullWidth horizontalAlign="center" gap={16}>
          <Button
            label="Upload Frame"
            iconLeft={"IcAdd"}
            size="large"
            onClick={handleUploadFrameClick}
          />
          {frameData?.portraitFrame && frameData?.landscapeFrame && (
            <Button
              label="Delete Frame"
              iconLeft={"IcTrash"}
              size="large"
              onClick={handleDeleteFrame}
              kind="secondary"
            />
          )}
        </Container>
        <Text
          text="Upload frames with dimensions 6144 X 6144"
          appearance="body-xs"
          color="primary-grey-80"
        />
      </Container>
      <PageLoader open={frameUploading || frameGetting || frameDeleting} />
    </Container>
  );
};

export default FrameModal;
